import styled from '@emotion/styled';

import colors from 'config/theme/colors';

export const Content = styled.div`
  width: 100%;
  > * {
    line-height: 14px;
  }
`;

export const SubContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #BABCBF;
  margin-top: 6px;
`;

export const Extension = styled.div`
  color: ${colors['@primary-color']};
  font-weight: 500;
`;
